import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from '../../config'
import { API_VERSION, NS_TOKEN } from '../../config'
import './PrivacyPolicy.css'
import ReactHtmlParser from 'react-html-parser';
import Oux from '../../hoc/Oux/Oux'

class PrivacyPolicy extends Component {
    state = {
        policy: null
    }

    componentDidMount() {
        axios.get(API_VERSION() + 'CTaxMobilePrivacyPolicy.php', {
            headers: {
                'ns-token': NS_TOKEN,
            },
        }).then(response => {
            console.log(response.data)
            this.setState({ policy: response.data })
            return response.data
        }).catch(error => {
            return error
        })
    }

    render() {

        let policy = (
            <Oux>
                <div class="clearfix"></div>
                <div className="container-login100">
                    <div className="privacy_policy text-center">
                        {ReactHtmlParser(this.state.policy)}
                    </div>
                </div>
            </Oux>
        )

        if (this.props.isLoggedIn) {
            policy = (
                <main className="main_section">
                    <div className="main_cont">
                        <div className="container-fluid fp_pl_0 fp_sub_sidenav_outer">
                            <div className="privacy_policy">
                                {ReactHtmlParser(this.state.policy)}
                            </div>
                        </div>
                    </div>
                </main>
            )
        }

        return policy
    }
}

const mapState = state => {
    return {
        isLoggedIn: state.authReducer.isLoggedIn
    }
}

export default connect(mapState)(PrivacyPolicy)